import { Text } from '@mantine/core';
import type { Device } from '@motionsafe/ms-console-api/admin/v1/device_pb.js';

import { ENDING_LENGTH, hardwareEnding } from '../lib/hardware';

const wrapId = { whiteSpace: 'normal', overflowWrap: 'anywhere' } as const;

// Which device this is, as one quiet line under the title: what it is, then
// its device identifier whole (The Identifier Rule), free to wrap, with the
// last six characters in full ink, since those are what people read out and
// match against the tablet. In their own case, so a copy of it is the id.
//
// `ending`: the last six alone, in capitals, as the tablet's own screen shows
// them, for a dialog that is matched against the tablet rather than copied.
export function DeviceLine({ device, from, ending = false }: { device: Device; from?: string | undefined; ending?: boolean }) {
  const id = device.hardwareId;
  return (
    <Text size="sm" c="dimmed" lh={1.5} mt={-4}>
      <Text span inherit c="var(--mantine-color-text)" fw={500}>{device.model || 'Device'}</Text>{' '}
      {id && ending && <>ending <Text span inherit className="id" c="var(--mantine-color-text)" fw={600}>{hardwareEnding(id)}</Text></>}
      {id && !ending && (
        <span className="id" style={wrapId}>
          {id.slice(0, -ENDING_LENGTH)}<Text span inherit c="var(--mantine-color-text)" fw={600}>{id.slice(-ENDING_LENGTH)}</Text>
        </span>
      )}
      {from ? <><br />Now with {from}</> : null}
    </Text>
  );
}
